import { Box, Tooltip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { TOrderRaw, TOrderRaw$Items } from "../api.js";
import { Link } from "react-router-dom";
import {
  dateTimeFormatter,
  formatContactPersonOrOrderId,
} from "../location-details/DoorCardUtils.js";

interface OrderListProps {
  order: TOrderRaw;
  location: string;
}

const OrderListBox = styled(Box)(({ theme }) => ({
  minWidth: "225px",
  width: "100%",
  borderRadius: "10px",
  backgroundColor: "#b7b8b8",
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",

  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    minWidth: "100%",
  },
}));

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "10px",
  alignItems: "baseline",
  flexWrap: "wrap",

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "6px",
  },
}));

const NoOverflowTypography = styled(Typography)(({ theme }) => ({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  flex: "1",
  minWidth: 0,

  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const OrderListItem = ({
  props,
  routeParams: { orderId, tenantKey },
}: {
  props: OrderListProps;
  routeParams: { orderId?: string; tenantKey: string };
}) => {
  const formattedContactPersonOrOrderId = formatContactPersonOrOrderId(
    props.order,
    tenantKey
  );
  const formattedDateTime = dateTimeFormatter(
    props.order.raw.startTime,
    props.order.raw.endTime,
  );

  return (
    <OrderListBox>
      <Row>
        <Tooltip title={props.location}>
          <NoOverflowTypography variant={"h5"} sx={{ m: { sm: "auto 2rem auto 1rem" } }}>
            {props.location}
          </NoOverflowTypography>
        </Tooltip>

        <Tooltip title={formattedContactPersonOrOrderId}>
          <NoOverflowTypography
            variant={"h5"}
            sx={{ m: { sm: "auto 2rem auto 6rem" } }}
          >
            <Link to={`/tenants/${tenantKey}/orders/${orderId}`}>
              {formattedContactPersonOrOrderId}
            </Link>
          </NoOverflowTypography>
        </Tooltip>

        <Tooltip
          title={props.order.raw.items
            .map((resType: TOrderRaw$Items) => resType.resourceTypes.join(", "))
            .join(", ")}
        >
          <NoOverflowTypography variant={"h5"} sx={{ m: { sm: "auto 0px auto auto" } }}>
            {" "}
            {props.order.raw.items
              .map((resType: TOrderRaw$Items) =>
                resType.resourceTypes.join(", "),
              )
              .join(", ")}{" "}
          </NoOverflowTypography>
        </Tooltip>

        <Tooltip title={formattedDateTime}>
          <NoOverflowTypography
            variant={"body1"}
            sx={{ m: { sm: "auto 1rem auto auto" } }}
          >
            {formattedDateTime}
          </NoOverflowTypography>
        </Tooltip>
      </Row>
    </OrderListBox>
  );
};
